export enum RouteEnum {
  STORE = '/',
  MATERIAL = '/material',
  COLOR = '/color',
  DESIGN = '/design-shape',
  ORDER_SUMMARY = '/order-summary',
  THANK_YOU = '/thank-you',
}

export type RouteState = {
  currentRoute: RouteEnum;
  routeHistory: RouteEnum[];
};
